import React, { Component } from 'react';
import styled from 'styled-components';
import Tooltip from '../../Tooltip';
import Button from '../../Button';
import Popup from '../../Popup';
import Checkbox from '../../Checkbox';
import { I18n } from 'react-redux-i18n';

const InputModalContainer = styled.div`
  .label {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.oswald};
    text-transform: uppercase;
    margin-bottom: 3px;
    letter-spacing: 1px;
    color: #2b3d54;
  }

  .labelContainer {
    height: 31px;
    display: flex;
    flex-direction: row;
  }

  .labelContainer > div {
    margin-left: 4px;
  }

  .tooltipContainer {
    width: 12px;
  }

  .inputModalValueContainer {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    display: flex;
    font-size: 12px;
    flex-direction: row;
    align-items: center;
    max-width: 75%;
    border-bottom: 1px solid #dbdddf;
    border-radius: 2px;
    min-height: 20px;
    color: ${(props) =>
      props.disabled ? 'rgba(23,44,57,0.3)' : props.theme.colors.dark};
    position: relative;
  }

  .inputModalButton {
    position: absolute;
    right: -80px;
    bottom: 1px;
  }

  .checkboxLabel {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};

    p {
      margin-left: 10px;
    }
  }

  .popupContent {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 2vw;
    width: 100%;
    margin-top: 20px;
    max-height: 80%;
    height: 100%;
    overflow-y: auto;
  }

  ${(props) => props.styles}
`;

class InputModal extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, selected: [] };
  }

  componentDidMount() {
    this.setState({ selected: this.props.selected });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps !== this.props &&
      prevProps.selected !== this.props.selected
    ) {
      this.setState({ selected: this.props.selected });
    }
  }

  handleCheckbox(label) {
    let { selected } = this.state;
    if (selected.includes(label)) {
      selected = selected.filter((item) => item !== label && item !== 'all');
    } else {
      selected.push(label);
    }
    this.setState({ selected });
  }

  handleOk() {
    const { onChange } = this.props;
    this.setState({ open: false });
    onChange(this.state.selected);
  }

  render() {
    const { value, label, tooltip, styles, allOption } = this.props;
    const data = this.props.data || [];
    const { open, selected } = this.state;
    const disabled = !(value && data && data.length > 0);
    return (
      <InputModalContainer disabled={disabled} styles={styles}>
        {label && (
          <div className="labelContainer">
            <p className="label">{label}</p>
            {tooltip && (
              <div className="tooltipContainer">
                <Tooltip {...tooltip} />
              </div>
            )}
          </div>
        )}
        <Popup
          open={open}
          title={I18n.t('editRivals')}
          size={{ width: '50vw', height: 'auto' }}
          icon="plus"
          onClose={() =>
            this.setState({ open: false, selected: this.props.selected })
          }
          onOk={() => this.handleOk()}
        >
          <div className="popupContent">
            {allOption && (
              <div key={`chekcboxInputModal-all`} className="checkboxLabel">
                <Checkbox
                  checked={selected.includes('all')}
                  onChange={() =>
                    selected.includes('all')
                      ? this.setState({ selected: [] })
                      : this.setState({ selected: [...data, 'all'] })
                  }
                />
                <p>{I18n.t('placeholderAll')}</p>
              </div>
            )}
            {data.map((item, index) => (
              <div
                key={`chekcboxInputModal-${index}`}
                className="checkboxLabel"
              >
                <Checkbox
                  checked={selected.includes(item)}
                  onChange={() => this.handleCheckbox(item)}
                />
                <p>{item}</p>
              </div>
            ))}
          </div>
        </Popup>
        <div className="inputModalValueContainer">
          <p>{disabled ? '' : value}</p>
          <div className="inputModalButton">
            <Button
              label={I18n.t('edit')}
              textTransform="normal"
              width="75px"
              fontWeight={400}
              height="25px"
              color="#e5e6e8"
              textColor="#868d95"
              onClick={() => this.setState({ open: true })}
              disabled={disabled}
            />
          </div>
        </div>
      </InputModalContainer>
    );
  }
}

export default InputModal;
